import { render, staticRenderFns } from "./RsaCartellaInfermieristicaEditComponent.vue?vue&type=template&id=6db7a5be"
import script from "./RsaCartellaInfermieristicaEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaCartellaInfermieristicaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports